import { enumify } from '../lib/typeInference.js';

export const credentialProviderValues = [
    'MOBILE',
    'EMAIL',
    'FACEBOOK', // deprecated but still in use
    'CFD', // deprecated
    'APPLE',
    'GOOGLE'
] as const;

export type CredentialProvider = (typeof credentialProviderValues)[number];
export const CredentialProviderEnum = enumify(credentialProviderValues);

export function isNonSSOCredentialProvider(obj: any): obj is 'MOBILE' | 'EMAIL' | 'FACEBOOK' | 'CFD' {
    return ['MOBILE', 'EMAIL', 'FACEBOOK', 'CFD'].includes(obj);
}

export interface ICredential<IDTYPE> {
    _id: IDTYPE;
    provider: CredentialProvider;
    id: string;
    // CHANGE made this required
    token: {
        salt: string; // FIXME we don't need to store this
        hashedPassword: string;
    };
    oldPasswordHashes?: string[];
    userId: IDTYPE;
    tenantId: IDTYPE;
    parentCredentialId?: IDTYPE;
    isVerified: boolean;
    isPrimary: boolean; // the credential used to login with
    created: Date;
}

export interface ICredentialId {
    provider: CredentialProvider;
    id: string; // email, phone number or id from SSO provider
}
